import { Form } from 'antd';
import { sumBy } from 'lodash';
import { useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';
import { formatCurrency, parseDecimal } from 'utils/formatCurrency';
import Button from '../Button';
import { IGroupCustomerItem } from '../types';
import useGetDepositValue from './useGetDepositValue';
type Props = {
  onClick?: () => void;
  value?: IGroupCustomerItem[];
};
const ButtonDeposit = ({ onClick, value: customers }: Props) => {
  const settingDeposit = shopSelectors.data.settingDepositBooking();
  const form = Form.useFormInstance();
  const getDepositValue = useGetDepositValue();

  const acceptPolicyDeposit = Form.useWatch(['acceptPolicyDeposit'], form);

  if (!settingDeposit?.active) return null;

  return (
    <Button disabled={!acceptPolicyDeposit} onClick={onClick}>PAY ({formatCurrency(getDepositValue(customers))})</Button>
  );
};

export default ButtonDeposit;
